export const AUTHENTICATED_HOME = "/paymentplan";
export const NOT_AUTHENTICATED_HOME = "/pages/login-page";


// WEBPACK FOOTER //
// ./src/routes/routesConstants.js